import React, { FunctionComponent } from 'react'
import { randomID } from '../../../redux/misc/helpers'
import { DetailedData, EggData } from '../../../redux/requests/products/product.types'
import { Direction } from '../../atoms/ArrowIcon'
import DetailsCard from '../../molecules/DetailsCard'

type OwnProps = {
  details: DetailedData[] | EggData[]
}

type Props = OwnProps

export const DetailsCardSection: FunctionComponent<Props> = ({ details }) => {
  const myList = details.map(item => {
    return <DetailsCard key={randomID()} details={item} direction={Direction.UP} moreIsBad={true} />
  })

  return <>{myList}</>
}

export default DetailsCardSection
